import { render, staticRenderFns } from "./EditPrivacyPortalModal.vue?vue&type=template&id=2514fb62&scoped=true"
import script from "./EditPrivacyPortalModal.vue?vue&type=script&lang=js"
export * from "./EditPrivacyPortalModal.vue?vue&type=script&lang=js"
import style0 from "./EditPrivacyPortalModal.vue?vue&type=style&index=0&id=2514fb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514fb62",
  null
  
)

export default component.exports